import BulkUploader from './BulkUploader';

export default BulkUploader;
